var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxl-facebook-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.0021 4.33789C14.0378 4.33789 4.33765 14.0381 4.33765 26.0024C4.33765 36.8141 12.259 45.7754 22.6178 47.4069V32.2662H17.1145V26.0024H22.6178V21.2292C22.6178 15.7952 25.8526 12.7987 30.7991 12.7987C33.1695 12.7987 35.6525 13.2212 35.6525 13.2212V18.5491H32.9138C30.2271 18.5491 29.3865 20.2217 29.3865 21.9356V25.9981H35.3903L34.4305 32.2619H29.3865V47.4026C39.7453 45.7797 47.6666 36.8162 47.6666 26.0024C47.6666 14.0381 37.9665 4.33789 26.0021 4.33789Z",
    fill: "#8A8575"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.06f584afca0ef0288c8f8d929ca255da.svg";
export { ForwardRef as ReactComponent };